jQuery(document).ready(function($) {
    
    // Adjust header layout based on admin bar
    function adjustLayout() {
        var siteHeaderHeight = $('.site-header').outerHeight();
        var adminBarHeight = $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0;
        $('.site-header').css('top', adminBarHeight);
        $('#sidr-main').css('top', adminBarHeight + siteHeaderHeight);
    }

    // Initial adjustment
    adjustLayout();

    // // Adjust on window resize
    $(window).resize(adjustLayout);
    $(window).load(adjustLayout);
    
    // Header Specfic JS
    // Header and Menu Scroll Handler
    var lastScrollTop = 0;
    var lastMenuScrollTop = 0;
    var header = $('.site-header');
    var headerHeight = header.outerHeight();

    $(window).scroll(function() {
        var scrollTop = $(this).scrollTop();
        var menuScrollDifference = Math.abs(scrollTop - lastMenuScrollTop);
        
        // Header visibility logic
        if (scrollTop > 0 && scrollTop < lastScrollTop) {
            header.addClass('header--sticky').removeClass('header--hidden');
        } else if (scrollTop > headerHeight) {
            header.addClass('header--hidden').removeClass('header--sticky');
        } else {
            header.removeClass('header--sticky header--hidden');
        }

        // Menu closing logic - only if scrolled more than 300px
        if (scrollTop > headerHeight) {
            // Close primary menu items
            $('#primary-menu > li.menu-item-has-children').removeClass('submenu-active');
            $('#primary-menu > li.menu-item-has-children > .sub-menu').slideUp(500);
            
            // Close utility menu items
            $('#utility-menu > li.menu-item-has-children').removeClass('submenu-active');
            $('#utility-menu > li.menu-item-has-children > .sub-menu-wrapper').slideUp(500);
            $('.utility-navigation-container').removeClass('menu-active');
            
            // Update the menu scroll position
            lastScrollTop = scrollTop;
        }

        // Update the header scroll position
        lastScrollTop = scrollTop;
    });

    /*******************************************
     * Mobile Menu Stuff *
     * We are using sidr to handle our menu JS *
     * https://www.berriart.com/sidr/ *
     *******************************************/

    var sidrName = "sidr-main";

    $(".mobile-navigation").sidr({
        name: sidrName,
        side: "right",
        source: ".main-navigation, .utility-navigation-container, .contact-button-container",
        renaming: false,
        onOpen: function() {
            $(window).on("click.sidr", function(e) {
                $.sidr("close", sidrName);
            });

            $("#mobile-menu-toggle").addClass("menu-open");
            $('body').append('<div class="mobile-menu-overlay"></div>');
            $('body').addClass('lock-scroll');
            $('#mobile-menu-toggle').addClass('close mobile menu');
            $('#mobile-menu-toggle.close').click(function() {
                $.sidr("close", sidrName);
            })
        },
        onClose: function() {
            $(window).off("click.sidr");
            $("#mobile-menu-toggle").removeClass("menu-open");
            $('.mobile-menu-overlay').remove();
            $('body').removeClass('lock-scroll');
            $('#mobile-menu-toggle').removeClass('close mobile menu');
        }
    });

    // Don't you dare close me out!
    $("#" + sidrName).on("click.sidr", function(e) {
        e.stopPropagation();
    });

   // Click event handler for primary menu items
    $('#primary-menu > li.menu-item-has-children > span').click(function(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent click from bubbling to document
        var $parent = $(this).parent();
        var $submenu = $parent.find('> .sub-menu');

        // Close other sub-menus
        $('#primary-menu > li.menu-item-has-children').not($parent).removeClass('submenu-active');
        $('#primary-menu > li.menu-item-has-children').not($parent).find('> .sub-menu').slideUp(300);

        // Toggle clicked sub-menu
        $submenu.slideToggle(300);
        $parent.toggleClass('submenu-active');
    });

    // Click event handler for utility menu items
    $('#utility-menu > li.menu-item-has-children > span').click(function(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent click from bubbling to document
        var $parent = $(this).parent();
        var $submenu = $parent.find('> .sub-menu-wrapper');

        // Close other sub-menus
        $('#utility-menu > li.menu-item-has-children').not($parent).removeClass('submenu-active');
        $('#utility-menu > li.menu-item-has-children').not($parent).find('> .sub-menu-wrapper').slideUp(300);

        // Toggle clicked sub-menu
        $submenu.slideToggle(300);
        $parent.toggleClass('submenu-active');
        $('.utility-navigation-container').toggleClass('menu-active');
    });

    // Close menus when clicking outside
    $(document).on('click', function(e) {
        if (!$(e.target).closest('#primary-menu, #utility-menu').length) {
            // Close primary menu items
            $('#primary-menu > li.menu-item-has-children').removeClass('submenu-active');
            $('#primary-menu > li.menu-item-has-children > .sub-menu').slideUp(300);
            
            // Close utility menu items
            $('#utility-menu > li.menu-item-has-children').removeClass('submenu-active');
            $('#utility-menu > li.menu-item-has-children > .sub-menu-wrapper').slideUp(300);
            $('.utility-navigation-container').removeClass('menu-active');
        }
    });

    // Update "Choose your country or region" for WPML FR-CA translation
    let lang = $('html').attr('lang');
    if (lang === 'fr-CA') {
        $('<style>')
          .prop('type', 'text/css')
          .html(`
            .utility-navigation .sub-menu-wrapper:before {
              content: 'Choisissez votre pays ou région:' !important;
            }
          `)
        .appendTo('head');
    }

});